var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.doNotUsePreloader && _vm.appStatus !== 'ready' && !_vm.fileDownloading && !_vm.inModal)?_c('div',{staticClass:"loader"},[_c('font-awesome-icon',{staticClass:"spinner",attrs:{"icon":"spinner"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }